import { PaypalAccountRedirect as PaypalAccountRedirectComponent } from './views/PaypalAccountRedirect';

export const PaypalAccountRedirect = PaypalAccountRedirectComponent; 